'use strict';

function cleanWhitespace(node, item, list) {
    list.remove(item);
}

module.exports = cleanWhitespace;
